
/**
 * Export `categories`.
 */

export const categories = {
  cultureAndSports: 'cultureAndSports',
  educationAndHealth: 'educationAndHealth',
  hotelsAndRestaurants: 'hotelsAndRestaurants',
  officeBuildings: 'officeBuildings',
  publicSpaces: 'publicSpaces',
  residentialBuildings: 'residentialBuildings',
  retail: 'retail'
};

/**
 * Export `categoriesValues`.
 */

export const categoriesValues = {
  [categories.cultureAndSports]: 'culture and sports',
  [categories.educationAndHealth]: 'education and health',
  [categories.hotelsAndRestaurants]: 'hotels and restaurants',
  [categories.officeBuildings]: 'office buildings',
  [categories.publicSpaces]: 'public spaces',
  [categories.residentialBuildings]: 'residential buildings',
  [categories.retail]: 'retail'
};
